import { createSelector } from 'reselect';

import { UI_TABS } from 'constants/ChatConstants';
import {
  getActiveTab,
  getCustomerConversationsPage,
  getInternalConversationsPage,
} from 'modules/chat/selectors/dashboard';
import { getCurrentUserId } from 'modules/users/selectors/currentUser';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

import { getDetailsFilters } from './details';

const pageParams = createSelector(
  getActiveTab,
  getCustomerConversationsPage,
  getInternalConversationsPage,
  (activeTab, conversationPage, internalPage) => (activeTab !== UI_TABS.INTERNAL ? conversationPage : internalPage)
);

const getUserId = createSelector(getActiveTab, getCurrentUserId, (activeTab, userId) =>
  (activeTab === UI_TABS.MY_CLIENT ? userId : undefined));

export const getRequestParams = createSelector(
  getDetailsFilters,
  getSelectedDealerId,
  getUserId,
  pageParams,
  ({ period, ...filters }, dealerId, userId, page) => ({ userId, dealerId, ...filters, ...page })
);
